import "../scss/rangemoors.scss";

window.$ = jQuery;

import lazysizes from "lazysizes";
import "lazysizes/plugins/respimg/ls.respimg";
import "lazysizes/plugins/bgset/ls.bgset";

import Cookies from "js-cookie";

var APPLICATION = {
  init: function () {},

  //site wide
  common: {
    init: function () {
      //Show/hide mobile menu listener
      $(".hamburger").click(APPLICATION.common.toggleMenu);

      //Show/hide sub menu listener
      $(".main-navigation .menu-item-has-children > a > span").click(
        APPLICATION.common.toggleSubMenu,
      );

      //Hide top message
      $(".top-message > span").click(APPLICATION.common.hideTopMessage);

      //Toggle product filter
      $(".woocommerce-layout .widget_text").click(
        APPLICATION.common.toggleFilter,
      );

      //Room size calculator
      $("#calculate_button").click(APPLICATION.common.roomSizeCalculate);

      //Header search bar action change
      $(".header__search-form select").change(
        APPLICATION.common.changeHeaderBarAction,
      );

      $(".search-and-tongue-toggle > div").click(
        APPLICATION.common.toggleSearchAndTongue,
      );

      $(".open-signup-popup").click(APPLICATION.common.openPluginPopup);

      //start sliders
      this.mainSlider();
      this.stovesSlider();
      this.blueSlider();
      this.contentSlider();
      this.ppcSlider();
      this.ppcHeroSlider();
      this.featuredSlider();
      this.featuredSliderRedesign();
      this.relatedSlider();
      this.likeSlider();
      this.videoMagnificPopup();
      this.formMagnificPopup();
      this.imageVideoMagnificPopup();
      this.removeOverlayImages();
      this.tabs();
      this.accordion();
      this.signUp();
      this.collapseMenu();
      this.cookerBuilderDialog();
    },

    getNewDialogElement(identifier, html) {
      if (document.getElementById(`${identifier}-rm-dialog`)) return false;

      let dialogElement = document.createElement("dialog");

      dialogElement.setAttribute("id", `${identifier}-rm-dialog`);
      dialogElement.innerHTML = `
        <a href="#close" class="rm-dialog-close tw-fixed tw-top-8 tw-h-10 tw-flex tw-bg-white tw-items-center tw-border-2 tw-border-solid tw-border-rm_green tw-justify-center tw-rounded-full tw-w-10 tw-z-50" tabindex="0" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0,0,256,256" class="tw-fill-white">
            <g fill="#000000" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(8.53333,8.53333)"><path d="M7,4c-0.25587,0 -0.51203,0.09747 -0.70703,0.29297l-2,2c-0.391,0.391 -0.391,1.02406 0,1.41406l7.29297,7.29297l-7.29297,7.29297c-0.391,0.391 -0.391,1.02406 0,1.41406l2,2c0.391,0.391 1.02406,0.391 1.41406,0l7.29297,-7.29297l7.29297,7.29297c0.39,0.391 1.02406,0.391 1.41406,0l2,-2c0.391,-0.391 0.391,-1.02406 0,-1.41406l-7.29297,-7.29297l7.29297,-7.29297c0.391,-0.39 0.391,-1.02406 0,-1.41406l-2,-2c-0.391,-0.391 -1.02406,-0.391 -1.41406,0l-7.29297,7.29297l-7.29297,-7.29297c-0.1955,-0.1955 -0.45116,-0.29297 -0.70703,-0.29297z"></path></g></g>
          </svg>
        </a>
        <div class="rm-dialog-inner">
        </div>
      `;

      html = document.createRange().createContextualFragment(html);
      dialogElement.querySelector(".rm-dialog-inner").append(html);

      // setup the close button.
      dialogElement
        .querySelector(".rm-dialog-close")
        .addEventListener("click", (evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          evt.target.closest("dialog").close("x");
        });

      return dialogElement;
    },

    // Add iframe dialog for cooker builder(s)
    // Added via shortcode:
    // [cooker-builder text="Open cooker builder" cid="5238"]
    cookerBuilderDialog() {
      Array.from(document.querySelectorAll(".open-cooker-builder")).forEach(
        (elm) => {
          const cid = elm.getAttribute("cid");
          if (cid) {
            const cookerBuilderDialog = this.getNewDialogElement(
              `cooker-builder-${cid}`,
              `<script type="module" src="https://static.isitetv.com/clients/lacanche/cookerbuilder/cooker-builder.js"></script>
                  <cooker-builder cid="${cid}"></cooker-builder>`,
            );

            if (cookerBuilderDialog) {
              document.body.append(cookerBuilderDialog);
              elm.addEventListener("click", (evt) => {
                evt.preventDefault();
                evt.stopPropagation();
                cookerBuilderDialog.showModal();
              });
            }
          }
        },
      );
    },

    //Show/hide mobile menu
    toggleMenu: function () {
      $("body").toggleClass("menu-open");
    },
    //Show/hide sub menu
    toggleSubMenu: function (e) {
      e.preventDefault();

      $(e.target).parent().parent().toggleClass("child-is-open");
    },
    toggleSearchAndTongue: function (e) {
      $(e.target).toggleClass("active");

      if (!$(e.target).parent().parent().hasClass($(e.target).attr("target"))) {
        $(e.target)
          .parent()
          .parent()
          .removeClass()
          .addClass($(e.target).attr("target"));
      } else {
        $(e.target).parent().parent().removeClass();
      }

      $(this).prev().removeClass("active");
      $(this).next().removeClass("active");
    },
    toggleFilter: function (e) {
      $("body").toggleClass("show-widgets");
    },
    //Remove top message & set 1 day cookie
    hideTopMessage: function (e) {
      $(e.target).parent().remove();

      Cookies.set("hide-alert-banner", "1", { expires: 1 });
    },
    openPluginPopup: function () {
      $("#modal-4573").show();
    },
    videoMagnificPopup: function () {
      $(".video-popup").magnificPopup({
        disableOn: 700,
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
      });
    },
    formMagnificPopup: function () {
      $(".popup-with-form").magnificPopup({
        type: "inline",
        preloader: false,
        focus: "#name",

        // When element is focused, some mobile browsers in some cases zoom in
        // It looks not nice, so we disable it:
        callbacks: {
          beforeOpen: function () {
            if ($(window).width() < 700) {
              this.st.focus = false;
            } else {
              this.st.focus = "#name";
            }
          },
        },
      });
    },
    imageVideoMagnificPopup: function () {
      $(".image-video-popup .aspect-ratio-holder__cover").click(function () {
        $(this).closest(".image-video-popup").find(".button").trigger("click");
      });

      $(".image-video-popup").each(function () {
        $(this).magnificPopup({
          delegate: "a",
          type: "image",
          callbacks: {
            elementParse: function (item) {
              // Function will fire for each target element
              // "item.el" is a target DOM element (if present)
              // "item.src" is a source that you may modify
              if (item.el.context.className == "video") {
                (item.type = "iframe"),
                  (item.iframe = {
                    patterns: {
                      youtube: {
                        index: "youtube.com/", // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                        id: "v=", // String that splits URL in a two parts, second part should be %id%
                        // Or null - full URL will be returned
                        // Or a function that should return %id%, for example:
                        // id: function(url) { return 'parsed id'; }

                        src: "//www.youtube.com/embed/%id%?autoplay=1", // URL that will be set as a source for iframe.
                      },
                      vimeo: {
                        index: "vimeo.com/",
                        id: "/",
                        src: "//player.vimeo.com/video/%id%?autoplay=1",
                      },
                      gmaps: {
                        index: "//maps.google.",
                        src: "%id%&output=embed",
                      },
                    },
                  });
              } else {
                (item.type = "image"),
                  (item.tLoading = "Loading image #%curr%..."),
                  (item.mainClass = "mfp-img-mobile"),
                  (item.image = {
                    tError:
                      '<a href="%url%">The image #%curr%</a> could not be loaded.',
                  });
              }
            },
          },
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
          },
        });
      });
    },
    //Change form action on header search form, when changing select dropdown
    changeHeaderBarAction: function (e) {
      $(e.target).parent().attr("action", $(this).val());

      $(".search-input").attr(
        "name",
        $(this).find("option:selected").data("name"),
      );

      if ($(this).find("option:selected").data("name") == "keyword") {
        $(".header__search-form").append(
          '<input type="hidden" class="virtuemart-inputs" name="view" value="category"><input class="virtuemart-inputs"  type="hidden" name="option" value="com_virtuemart">',
        );
      } else {
        $(".virtuemart-inputs").remove();
      }
    },
    roomSizeCalculate: function (e) {
      e.preventDefault();

      var length = jQuery("#kwh-length").val(),
        width = jQuery("#kwh-width").val(),
        height = jQuery("#kwh-height").val(),
        fueltype = jQuery("#kwh-calculator #fuel_type").val(),
        result = "";

      $("#result_fuel_type").val(fueltype);

      if ($("#unit-metres").prop("checked")) {
        result = (length * width * height) / 14;
      } else {
        result = (length * width * height) / 500;
      }

      $(".kwh-result-container").show();

      $("#kwh-result").html(result.toFixed(2) + " kWh");

      $("#form-kwh").val(result.toFixed(2));
    },
    mainSlider: function () {
      $(".main-slider").owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        autoplay: true,
        navText: ["", ""],
        linked: ".blue-owl-carousel",
        responsive: {
          0: {
            items: 1,
          },
        },
      });
    },
    stovesSlider: function () {
      var owl = $(".stoves-slider");

      owl.owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        autoplay: false,
        navText: ["", ""],
        dots: true,
        responsive: {
          0: {
            items: 1,
          },
        },
      });

      function myfunc() {
        if (this.currentTime > this.duration - 5) {
          owl.trigger("play.owl.autoplay");
        }
      }

      function videoslide() {
        if ($(".owl-item.active .item-video").length) {
          owl.trigger("stop.owl.autoplay");
          var video = $(".owl-item.active video").get(0);
          video.play();
          video.addEventListener("timeupdate", myfunc, false);
        }
      }

      owl.on("translated.owl.carousel", videoslide());

      owl.on("changed.owl.carousel", function (property) {
        var current = property.item.index;
        var video = $(property.target)
          .find(".owl-item")
          .eq(current)
          .find(".item-video video")
          .get(0);
        if (video) {
          owl.trigger("stop.owl.autoplay");
          video.play();
          video.addEventListener("timeupdate", myfunc, false);
        }
      });
    },
    blueSlider: function () {
      $(".blue-owl-carousel").owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        navText: ["", ""],
        autoplay: true,
        animateOut: "fadeOut",
        mouseDrag: false,
        linked: ".main-slider",
        responsive: {
          0: {
            items: 1,
          },
        },
      });
    },
    contentSlider: function () {
      $(".content-gallery").owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        navText: ["<", ">"],
        responsive: {
          0: {
            items: 1,
          },
        },
      });
    },
    ppcSlider: function () {
      $(".ppc-landing__gallery").owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        navText: ["<", ">"],
        responsive: {
          0: {
            items: 1,
          },
        },
        autoplay: true,
      });
    },
    ppcHeroSlider: function () {
      $(".ppc-landing__hero-carousel").owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        navText: ["", ""],
        responsive: {
          0: {
            items: 1,
          },
        },
        autoplay: true,
      });
    },
    featuredSlider: function () {
      $(".featured-products ul.products").addClass("owl-carousel");

      $(".featured-products ul.products").owlCarousel({
        loop: true,
        margin: 40,
        nav: true,
        navText: ["", ""],
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
          850: {
            items: 3,
          },
          1100: {
            items: 4,
          },
        },
      });
    },

    featuredSliderRedesign: function () {
      $(".featured-products-redesign ul.products").addClass("owl-carousel");

      $(".featured-products-redesign ul.products").owlCarousel({
        loop: true,
        margin: 40,
        nav: true,
        navText: ["", ""],
        items: 1,
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        mouseDrag: false,
      });
    },

    relatedSlider: function () {
      $(".related.products ul.products").addClass("owl-carousel");

      $(".related.products ul.products").owlCarousel({
        loop: true,
        margin: 40,
        nav: true,
        dots: false,
        navText: ["", ""],
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
        },
      });
    },

    likeSlider: function () {
      $(".up-sells ul.products").addClass("owl-carousel");

      $(".up-sells ul.products").owlCarousel({
        loop: true,
        margin: 40,
        nav: true,
        dots: false,
        navText: ["", ""],
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
        },
      });
    },

    removeOverlayImages: function () {
      if ($(".woocommerce-product-gallery__wrapper")[0]) {
        setInterval(function () {
          if (
            $(
              ".woocommerce-product-gallery__wrapper div:not(:first-child)",
            ).hasClass("flex-active-slide")
          ) {
            $(".energy_rating").hide();
          } else {
            $(".energy_rating").show();
          }
        }, 100);
      }
    },

    tabs: function () {
      $(".tab").click(function () {
        var tab = $(this).attr("data-tab");
        $(".tab").removeClass("active");
        $(this).addClass("active");
        $(".tab-content").removeClass("active");
        $("." + tab).addClass("active");
      });
    },

    accordion: function () {
      $(".woocommerce-accordion > .accordion-heading").click(function (e) {
        e.preventDefault();
        $(this).toggleClass("active");
        $(this).next(".woocommerce-accordion-panel").slideToggle(250);
      });
    },

    collapseMenu: function () {
      $(".menu-title").click(function (e) {
        e.preventDefault();
        $(this).toggleClass("open");
        $(this).next(".left-menu").slideToggle(250);
      });
    },

    signUp: function () {
      function createCookie(name, value, days) {
        var date, expires;
        if (days) {
          date = new Date();
          date.setDate(date.getDate() + days);
          expires = "; expires=" + date.toUTCString();
        } else {
          expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
      }

      function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == " ") c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
        }
        return null;
      }

      $(".sign-up-btn").click(function () {
        $("body").addClass("sign-up-fixed");
        createCookie("signup", 1, 60);
      });
      $(".newsletter-signup .close").click(function () {
        $("body").removeClass("sign-up-fixed");
      });

      var signupCookie = readCookie("signup");
      if (!signupCookie) {
        window.setTimeout(function () {
          $("body:not(.sign-up-fixed)").addClass("sign-up-fixed");
          createCookie("signup", 1, 60);
        }, 60000);
      }
    },

    finalize: function () {
      console.log(
        "%c Made by Designamite",
        "color:#222; background: url(data:image/png;base64,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); background-size:contain; padding-left: 10px; background-position: left center; background-repeat: no-repeat;",
      );
    },
  },
};

//http://www.paulirish.com/2009/markup-based-unobtrusive-comprehensive-dom-ready-execution/
window.UTIL = {
  fire: function (func, funcname, args) {
    var namespace = APPLICATION; // indicate your obj literal namespace here

    funcname = funcname === undefined ? "init" : funcname;
    if (
      func !== "" &&
      namespace[func] &&
      typeof namespace[func][funcname] == "function"
    ) {
      namespace[func][funcname](args);
    }
  },

  loadEvents: function () {
    var bodyId = document.body.id;

    // hit up common first.
    UTIL.fire("common");

    // do all the classes too.
    $.each(document.body.className.split(/\s+/), function (i, classnm) {
      UTIL.fire(classnm);
      UTIL.fire(classnm, bodyId);
    });

    UTIL.fire("common", "finalize");
  },
};

$(function () {
  UTIL.loadEvents();
});
